var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointThreeicon = function SvgPointThreeicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.245 8.25v-.96c0-.07.04-.11.11-.11h.55c.81 0 1.09-.37 1.09-.82 0-.49-.35-.78-.96-.78-.52 0-.98.28-1.1.88-.03.11-.05.12-.13.12h-.95c-.09 0-.13-.06-.13-.17.08-1.17 1.08-2.01 2.27-2.01 1.27 0 2.22.73 2.22 1.86 0 .6-.28 1.1-.77 1.45.45.21 1.07.73 1.07 1.75 0 1.35-1.03 2.14-2.52 2.14-1.36 0-2.43-.84-2.51-2.28.01-.11.05-.17.13-.17h.94c.08 0 .13.02.14.13.08.84.7 1.14 1.36 1.14.71 0 1.22-.36 1.22-1.08 0-.6-.45-.98-1.37-.98h-.55c-.07 0-.11-.04-.11-.11Z"
  })));
};
export default SvgPointThreeicon;